import { Card, notification, Tooltip } from "antd";
import { CloseOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { AppConstants } from "../../../Appconstants";
import { connect } from "react-redux";
import { setDocumentAttachmentsData } from "../../../redux/actions/UI/createDocument";

interface IVisitorImageProps {
  setDocumentAttachmentsData: Function;
}

const VisitorImage: React.FC<IVisitorImageProps> = ({
  setDocumentAttachmentsData,
}) => {
  const [visitorImage, setVisitorImage] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openNotificationWithIcon = (type: any, message: string) => {
    notification.open({
      message: message,
      type: type,
      duration: 3,
    });
  };

  useEffect(() => {
    if (visitorImage) {
      const objectUrl = URL.createObjectURL(visitorImage);
      setPreviewUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreviewUrl(null);
    }
  }, [visitorImage]);

  useEffect(() => {
    setDocumentAttachmentsData(visitorImage ? [visitorImage] : []);
  }, [visitorImage]);

  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || event.target.files.length === 0) return;

    const selectedFile = event.target.files[0];
    const fileSizeLimit = 5 * 1024 * 1024;

    if (selectedFile.size > fileSizeLimit) {
      openNotificationWithIcon(
        "error",
        `File "${selectedFile.name}" exceeds the 5 MB size limit.`
      );
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    if (!selectedFile.type.startsWith("image/")) {
      openNotificationWithIcon("error", "Please upload a valid image file.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    setVisitorImage(selectedFile);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleDeleteImage = () => {
    setVisitorImage(null);
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Card className="custom-card no-header-border flex-grow-1 fileCard">
      <div className="card-content">
        <div className="title mb-10 fS-20">
          {AppConstants.VISITOR_IMAGE_DETAIL.VISITOR_IMAGE_LABEL} &nbsp;
          <Tooltip
            title={AppConstants.VISITOR_IMAGE_DETAIL.VISITOR_IMAGE_LABEL}
          >
            <InfoCircleOutlined className="info-icon" />
          </Tooltip>
        </div>
        <input
          type="file"
          accept="image/*"
          capture
          onChange={handleImageChange}
          ref={fileInputRef}
        />
        {!previewUrl && (
          <div className="file-size-info">
            {AppConstants.VISITOR_IMAGE_DETAIL.VISITOR_IMAGE_UPLOAD_DETAILS}
          </div>
        )}
        <div>
          {previewUrl ? (
            <div className="image-preview-container">
              <img
                src={previewUrl}
                alt="Visitor preview"
                className="previewImage"
              />
              <Tooltip title="Remove">
                <CloseOutlined
                  className="remove-icon-cross"
                  onClick={handleDeleteImage}
                />
              </Tooltip>
            </div>
          ) : null}
        </div>
      </div>
    </Card>
  );
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  setDocumentAttachmentsData: (payload: File[]) =>
    dispatch(setDocumentAttachmentsData(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(React.memo(VisitorImage));
